// Product ID to single Variant ID mapping
let tangent_selected_product_map;

let default_addToCartText = "Add To Cart";
const default_addedToCartText = "Added to Cart!";
const default_subscriptionAddedToCartText = "Subscription Added!";
const default_add_all_to_cart_text = "Add All to Cart";
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

let tangent_client_domain_currency;

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Tab title mapping based on tags
const tabs_title_mapping={
    section_basics:"Start",
    section_essentials:"Build",
    section_works:"Refine"
}; 

const TAB_EXCLUDED_SECTIONS = [
    "section_selfie"
];


// Add default image url here
const tangent_default_selfie_image_url="https://cdn.shopify.com/s/files/1/0774/0968/1692/files/Skinquiz_default_image_4x5_7d426aad-4226-4f4d-89b4-448295c525c2.jpg";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 
const tangent_condition_message_popoup = document.querySelector("#tangent-popup-condition-message"); 

// Message for each conditions
const condition_text_mapping = {
    dark_circles: "Prone to dark circles here! Try our <a target='_blank' href='https://www.emkskincare.com/products/radical-eye-cream'><u>Radical Eye Cream</u></a>.",
    wrinkles: "Prone to wrinkles here! Try our <a target='_blank' href='https://www.emkskincare.com/products/c-x-3-gold-serum'><u>Cx3 Gold Serum</u></a>",
    rosacea: "Prone to rosacea here! Try our <a target='_blank' href='https://www.emkskincare.com/products/rescue-serum'><u>Rescue Serum</u></a>",
    texture: "Prone to texture here! Try our <a target='_blank' href='https://www.emkskincare.com/products/supra-face-cream'><u>Supra Face Cream</u></a>",
    darkspots: "Prone to darkspots here! Try our <a target='_blank' href='https://www.emkskincare.com/products/c-x-3-gold-serum'><u>Cx3 Gold Serum</u></a>",
    acne: "Prone to Blemish here! Try our <a target='_blank' href='https://www.emkskincare.com/products/rescue-serum'><u>Rescue Serum</u></a>"
}

window.onload = function() {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
    // Current Page Load URL
    let tangent_client_url = new URL(window.location.href);
    return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
    if (tangent_response_id != null) {
        const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
        fetch(checkout_url)
        .then(data => {
            return data.json();
        })
        .then(response => {
            checkoutDataProcess(response);
            return response;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}

function checkoutDataProcess(response){
    const tangent_recommended_products = response.products;

    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    setElementDisplay("loading-section", "none");
    if (response["selfie_id"] != null) {
        setElementDisplay("tangent-loading-section", "flex");
        setSelfieId(response["selfie_id"]);
        getSelfieMapping(response["selfie_id"]);
        enableSelfieDependedStaticElements();
    }
    else {
        setTangentDefaultSelfie();
    }

    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
        createProductSection(tangent_product_sections, tangent_text_sections);
    }    
  
    if(response.text_sections!=undefined){
        createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
        enableButtonListener();
        loadElementsOnResponseData(); 

        setTabOpen(response.tags);
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
}

function setTabOpen(tags = []) {
  const tabWrapper = document.querySelector("#tab-wrapper");
  const tabContents = document.querySelectorAll(".tabcontent");
  const tabButtons = document.querySelectorAll(".tablinks");

  tabWrapper.style.display = "block";

  // Determine active tab index
  let activeIndex = 0;
//   if (tags.includes("routine_10_mins")) activeIndex = 1;
//   else if (!tags.includes("routine_5_mins")) activeIndex = 2;

  // Hide all tabs and deactivate buttons
  tabContents.forEach(tc => (tc.style.display = "none"));
  tabButtons.forEach(btn => btn.classList.remove("active"));
  // Safely activate the chosen tab if it exists
  if (tabContents[activeIndex] && tabButtons[activeIndex]) {
    tabContents[activeIndex].style.display = "block";
    tabButtons[activeIndex].classList.add("active");
  }
}

// Setting Selfie / Default Image
function setTangentDefaultSelfie() {
    const selfieImage = document.getElementById("tangent_selfie_image");
    if (tangent_default_selfie_image_url) {
        setElementDisplay("loading-section", "none");
        setElementDisplay("canvas_img", "block");
        setElementDisplay("tangent_selfie_image", "flex");
        selfieImage.src = tangent_default_selfie_image_url;
        document.getElementById("section_selfie_container_parent").style.borderBottom = "none";
    } else {
        setElementDisplay("tangent_selfie_container", "none");
    }
}


// Selfie Mapping data api call
async function getSelfieMapping(selfie_id) {
    const selfie_api_url = `https://service.tangent.ai/shopify/upload-selfie?selfie_id=${selfie_id}&user=mango`;

    try {
        const res = await fetch(selfie_api_url);
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const data = await res.json();
        tangent_facemap_data = data?.selfie_record?.[0]?.facemap;
        if (tangent_facemap_data) {
            // Update scores
            setScores(tangent_facemap_data.scores);

            // Update selfie image
            const canvasImg = document.getElementById("canvas_img");
            if (canvasImg) canvasImg.src = tangent_facemap_data.url;
        }

        // Hide loading, show image
        setElementDisplay("selfie-loading-section", "none");
        setElementDisplay("canvas_img", "block");

    } catch (err) {
        console.error("Error fetching selfie:", err);
        setElementDisplay("loading-section", "none");
    }
}

// Setting scores below the selfie
function setScores(scores) {
    let scores_present = false;

    const scoreMap = {
        acne: "Acne",
        rosacea: "Rosacea",
        darkspots: "DarkSpots",
        wrinkles: "Wrinkles",
        dark_circles: "DarkCircles",
        texture: "Texture"
    };

    Object.keys(scores).forEach(key => {
        if (scoreMap[key]) {
            const containerId = `${scoreMap[key]}_Score_container`;
            const scoreId = `#${scoreMap[key]}_Score`;
            setElementDisplay(containerId, "flex");
            document.querySelector(scoreId).innerHTML = scores[key] + "%";
            scores_present = true;
        }
    });

    if (scores_present) {
        setElementDisplay("facemap_all_scores_container", "flex");
    }
}

function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};

    Object.keys(sections).forEach(section => {
        const product_ids = sections[section];
        const product_section_grid = document.getElementById(section + "_product_grid");

        // Create a document fragment for improved performance
        const fragment = document.createDocumentFragment();

        for (const id of product_ids) {
            for (let p = 0; p < products.length; p++) {
                // Find product by ID
                if (String(products[p].id) === id) {
                const product = products[p];
                const variant = getSelectedVariant(product, selected_variants[product.id]);
                    
                // Track selected product variant
                tangent_selected_product_map[product.id] = extractVariantId(variant.id);
                
                // Generate product HTML and append it to the fragment
                const product_html = getProductHTML(product, p, variant, section, sections);
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = product_html;

                // Append the created product HTML to the fragment
                while (tempDiv.firstChild) {
                    fragment.appendChild(tempDiv.firstChild);
                }
                }
            }
        }
        // Append the fragment to the DOM in one go
        product_section_grid.appendChild(fragment);
    });
}


function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants.edges || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => extractVariantId(variant.node.id) === selectedVariantId) || productVariants[0].node;
  }
  
  return productVariants[0].node;
}

function getProductHTML(product, index, variant, section, sections) {

    const variantId = extractVariantId(variant.id);
    // Setting default / first variant data
    const variant_image_url = getVariantImage(variant, product);
    const variant_product_url = `${tangent_client_domain_url}/products/${product.handle}?variant=${variantId}`;

    let variantTitle= variant.title;
    if(variantTitle=="Default Title"){
        variantTitle="";
    }

    const variantPrice = parseFloat(variant.price).toString()

    let buttonClass="";
    let buttonText = default_addToCartText;
    if(isProductAvailable(product, variant)){
        updateSectionAllToCartLink(sections, product.id, tangent_selected_product_map[product.id], section);
    }
    else{
        buttonText = out_of_stock_text;
        buttonClass ="disable-button";
    }
    
    // Product View HTML using template literals
    const product_html = `
        <div class="our-prducts-box">
            <div>
                <div class="tangent-product-image-container">
                    <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variant_product_url}">
                        <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
                    </a>
                </div>
                <div>
                    <p class="tangent-product-title tangent_product_title_text">${product.title}</p>
                    <p class="tangent_variant_title">${variantTitle}</p>
                </div>
            </div>
            <div class="tangent-product-content">
                <p id="price_tangent_product_${index}" class="tangent_product_price_text grid-product__price--current">${variantPrice} SEK</p>
                <button class="btn btn--primary quick-add-btn js-quick-add-btn tangent-product-add-btn-wrapper tangent_add_to_cart_button product-buy-buttons--cta ${buttonClass}" id="${variantId}" data-add-to-cart="${variantId}" data-section="${section}">
                    ${buttonText}
                </button>
                
                ${getSellingPlanButton(product, variantId, buttonClass,section)}    
            </div>
        </div>
    `;
    
    return product_html;
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status !== "ACTIVE") {
      return false;
  }
  return variant.availableForSale;
}

function getSellingPlanButton(product, variantId, buttonClass, section) {
  if (product?.sellingPlanGroups?.edges?.length > 0) {
    const groupNode = product.sellingPlanGroups.edges[0].node;

    if (groupNode?.sellingPlans?.edges?.length > 0) {
      const planNode = groupNode.sellingPlans.edges[0].node;
      const planId = extractSellingId(planNode.id);
      return `<button class="tangent-product-add-btn-wrapper-subscribe tangent_add_to_cart_button tangent-product-add-btn-subscribe ${buttonClass}" id="${variantId}" data-planid="${planId}" data-section="${section}"><span>Subscribe</span></button>`;
    }
  }
  return ``;
}


// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections, product_id, vid) {
    if (!product_sections) return;

    for (const section in product_sections) {
        if (product_sections[section].includes(String(product_id))) {
            // Initialize section if it doesn't exist
            if (!sections_add_to_cart_map[section]) {
                sections_add_to_cart_map[section] = {
                    count: 0,
                    cart_link: tangent_client_domain_url + "/cart/add?",
                    list: []
                };
            }

            // Update section if vid is not already included
            const sectionData = sections_add_to_cart_map[section];
            if (!sectionData.list.includes(vid)) {
                sectionData.count++;
                sectionData.cart_link += `&id[]=${vid}`;
                sectionData.list.push(vid);

                // Show "Add All to Cart" button if more than one product
                const addAllButton = document.getElementById(`${section}_add_all_to_cart`);
                if (addAllButton) {
                    addAllButton.style.display = sectionData.count > 1 ? "block" : "none";
                }
            }
        }
    }
}

const getVariantImage = (variant, product) => {
  if(variant.image?.url){
    return variant.image.url; 
  }
  else{
    if(product.images?.nodes[0]?.url){
        return product.images.nodes[0].url
    }
    else{
      return 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
  }
}

function createFormDataFromIds(idArray, element) {
    const section = element.getAttribute('data-section');
    if (element.getAttribute('data-planid')) {
        return {
        items: idArray.map(id => ({
            id: id,
            quantity: 1,
            selling_plan: element.getAttribute('data-planid')
        }))
        };
    }

    const items = idArray.map(id => {
        const baseItem = { id, quantity: 1 };

        // const sectionTypeMap = {
        // section_basics: "tangent-basics-product",
        // section_essentials: "tangent-essentials-product",
        // section_works: "tangent-works-product"
        // };

        // if (sectionTypeMap[section]) {
        // baseItem.properties = {
        //     _type: sectionTypeMap[section],
        //     _variantIds: idArray
        // };
        // }

        return baseItem;
    });
    
    return { items };
}

function extractSellingId(id){
  return id.replace("gid://shopify/SellingPlan/", "");
}

function addToCart(element){ 
    const formData = createFormDataFromIds([element.id], element);
    addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
    const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list, element);
    if(formData){
        addToCartApi(formData, element);
    } 
    else {
        var x = document.querySelector("#message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

function addToCartApi(payload, element){ 
  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`;
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  })
  .then(async (response) => {
    const data = await response.json();

    if (!response.ok) {
      throw data;
    }
    if(element.getAttribute('data-planid')){
        element.innerHTML = default_subscriptionAddedToCartText;
    }
    else{
        element.innerHTML = default_addedToCartText;
    }
    element.classList.add("added-to-cart-style"); 
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.getElementById('cart-drawer')?.show();
    return data;
  })
  .catch((error) => {
    if (error && error.status) {
      const message = error.message || "Something went wrong";

      element.innerHTML = "Add to Cart";
      element.classList.remove("added-to-cart-style");

      showCartError(element, message);
    } 
  });
}


function extractVariantId(variantId) {
  return variantId.replace("gid://shopify/ProductVariant/", "");
}


function showCartError(targetElement, message) {
  if (!targetElement) return;

  const parent = targetElement.parentNode;

  // Remove existing message
  const existing = parent.querySelector('.tangent-cart-error-msg');
  if (existing) existing.remove();

  const el = document.createElement('p');
  el.textContent = message;
  el.className = 'tangent-cart-error-msg';

  targetElement.insertAdjacentElement('afterend', el);

  // Store timeout on element to prevent multiple timers
  if (targetElement._errorTimeout) {
    clearTimeout(targetElement._errorTimeout);
  }

  targetElement._errorTimeout = setTimeout(() => {
    const msg = parent.querySelector('.tangent-cart-error-msg');
    if (msg) msg.remove();
  }, 4000);
}

// Main Section container 
function createSectionContainer(section_name) {
  const section_container = document.createElement("div");
  section_container.id = `${section_name}_container`;

  if (!TAB_EXCLUDED_SECTIONS.includes(section_name)) {
    section_container.classList.add("tabcontent");
  }

  section_container.classList.add(`${section_name}_container`);
  return section_container;
}


function createSectionAddAllToCart(section_name) {
    const add_all_to_cart_button = document.createElement("button");
    add_all_to_cart_button.id = section_name;
    add_all_to_cart_button.classList.add("section_add_all_to_cart", section_name+"_add_all_to_cart", "btn");
    add_all_to_cart_button.innerHTML = default_add_all_to_cart_text;

    // Enabling listener
    add_all_to_cart_button.addEventListener(
        'click',
        function () { addAllTocartFunction(add_all_to_cart_button); },
        false
    );
    return add_all_to_cart_button;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Tab buttons 
function createTabButton(section_name) {
    const tab_button = document.createElement("button");
    tab_button.id = `${section_name}_tab_button`;
    tab_button.textContent = getTabTitle(section_name); // safer than innerHTML if text only
    tab_button.name = section_name;
    tab_button.classList.add("tablinks", `${section_name}_tab_button`);

    // Click listener
    tab_button.addEventListener("click", () => switchTab(tab_button));

    tangent_custom_tabs.appendChild(tab_button);
}

// Handle Tab button selection
function switchTab(element) {
  let i, tabcontent, tablinks;

  // This is to clear the previous clicked content.
  tabcontent = document.querySelectorAll(".tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  
  tablinks = document.querySelectorAll(".tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Display the clicked tab and set it to active.
  document.getElementById(element.name+"_container").style.display = "flex";
  document.getElementById(element.name+"_tab_button").classList.add("active");
}

function getTabTitle(section) {
  // Use mapped title if available
  if (tabs_title_mapping && tabs_title_mapping[section] !== undefined) {
    return tabs_title_mapping[section];
  }

  // Fallback: clean up the section name
  return section
    .replace(/^section_/, "")  // Remove only prefix "section_"
    .replace(/_/g, " ")        // Replace ALL underscores with spaces
    .trim()
    .replace(/\b\w/g, c => c.toUpperCase()); // Capitalize each word
}


// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
        // The created container will have both a container to show text and products
        var section_container = createSectionContainer(section_name);    

        // Creating text sections before products sections if exists
        if(text_sections!=undefined){
            createTextSectionBeforeProducts(text_sections,section_container,section_name);
        }    
        
        // Creating section to add all products
        section_container.appendChild(addSectionProductGridContainer(section_name));

        // Creating add all to cart button for the section    
        section_container.appendChild(createSectionAddAllToCart(section_name));

        // Add to main container wrapper
        tangent_sections_wrapper_element.appendChild(section_container);

        if (!TAB_EXCLUDED_SECTIONS.includes(section_name)) {
            createTabButton(section_name);
        }
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_selfie.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Enabling button listeners
function enableButtonListener() {
    document.querySelectorAll(
        '.tangent-product-add-btn-wrapper, .tangent-product-add-btn-wrapper-subscribe'
    ).forEach(function(btn) {

        btn.onclick = function () {
            addToCart(this);
        };

    });

}

// Show elements after response data loads
function loadElementsOnResponseData(){
    const elements = document.querySelectorAll('.load-on-data');
    if (!elements.length) return;

    elements.forEach(el => {
        el.style.display = "block";
    });
}

function setElementDisplay(elementId, display) {
    const el = document.querySelector("#" + elementId);
    if (el) {
        el.style.display = display;
    }
}

function enableSelfieDependedStaticElements() {
    setElementDisplay("tangent_score_description", "block");
}

function setSelfieId(id) {
    tangent_selfie_id = id;
}

function getSelfieId() {
    return tangent_selfie_id;
}

// Called on image on load function
function drawOnCanvas() {
    if (getSelfieId() != null) {

        var selfie_canvas = document.querySelector('#selfie_canvas');
        var selfie_canvas_ctx = selfie_canvas.getContext('2d');

        selfie_canvas.addEventListener('click', function (e) {
            getCursorPosition(selfie_canvas, e)
        });

        var canvas_img = document.querySelector('#canvas_img');
        setCanvasDimensions(selfie_canvas, canvas_img);

        var prop = getImageSize(canvas_img.naturalWidth);

        drawDarkCircleContours(selfie_canvas_ctx, tangent_facemap_data["dark_circles"], getDarkCircleBlur(prop));
        drawWrinkleContours(selfie_canvas_ctx, tangent_facemap_data["wrinkles"], getWrinkleLineWidth(prop));
        drawRosaceaContours(selfie_canvas_ctx, tangent_facemap_data["rosacea"], getRosaceaBlur(prop));
        drawTextureContours(selfie_canvas_ctx, tangent_facemap_data["texture"], getTextureLineWidth(prop));
        drawDarkSpotsContours(selfie_canvas_ctx, tangent_facemap_data["darkspots"], getDarkSpotsLineWidth(prop));
        drawAcneContours(selfie_canvas_ctx, tangent_facemap_data["acne"], getAcneLineWidth(prop));
    }
}

const setCanvasDimensions = (selfie_canvas, canvas_img) => {
    selfie_canvas.width = canvas_img.naturalWidth;
    selfie_canvas.height = canvas_img.naturalHeight;
}

const getImageSize = (imgWidth) => {
    var prop = imgWidth / 400;
    return prop;
}

const getDarkCircleBlur = (prop) => {
    if (prop < 1) {
        return 'blur(1px)';
    }
    else if (prop < 1.5) {
        return 'blur(2px)';
    }
    else if (prop < 2) {
        return 'blur(4px)';
    }
    else if (prop < 3) {
        return 'blur(7px)';
    }
    else if (prop < 4) {
        return 'blur(12px)';
    }
    else {

    }
}

const getRosaceaBlur = (prop) => {
    if (prop < 1) {
        return 'blur(4px)';
    }
    else if (prop < 1.5) {
        return 'blur(4px)';
    }
    else if (prop < 2) {
        return 'blur(5px)';
    }
    else if (prop < 3) {
        return 'blur(13px)';
    }
    else if (prop < 4) {
        return 'blur(18px)';
    }
    else {
        console.log("out of bound props - Rosacea");
    }
}

const getAcneLineWidth = (prop) => {
    if (prop < 0.5) {
        return 2;
    }
    else if (prop < 1) {
        return 4;
    }
    else if (prop < 1.5) {
        return 7;
    }
    else if (prop < 2) {
        return 10;
    }
    else if (prop < 3) {
        return 14;
    }
    else if (prop < 4) {
        return 15;
    }
    else {
        console.log("out of bound props - Acne");
    }
}

const getDarkSpotsLineWidth = (prop) => {
    if (prop < 1) {
        return 1;
    }
    else if (prop < 1.5) {
        return 6;
    }
    else if (prop < 2) {
        return 6;
    }
    else if (prop < 3) {
        return 14;
    }
    else if (prop < 4) {
        return 15;
    }
    else {
        console.log("out of bound props - DarkSpots");
    }
}

const getTextureLineWidth = (prop) => {
    if (prop < 0.5) {
        return 2;
    }
    else if (prop < 1) {
        return 3;
    }
    else if (prop < 1.5) {
        return 6;
    }
    else if (prop < 2) {
        return 10;
    }
    else if (prop < 3) {
        return 14;
    }
    else if (prop < 4) {
        return 16;
    }
    else {
        return 20;
    }
}

const getWrinkleLineWidth = (prop) => {
    if (prop < 1) {
        return 4;
    }
    else if (prop < 1.5) {
        return 6;
    }
    else if (prop < 2) {
        return 10;
    }
    else if (prop < 3) {
        return 15;
    }
    else if (prop < 4) {
        return 30;
    }
    else {
        console.log("out of bound props - Wrinkle");
    }
}

const drawDarkCircleContours = (context, eye_contours, filter) => {
    context.filter = filter;
    context.fillStyle = 'rgba(28, 30, 82, 0.3)';
    drawContours(context, eye_contours, true, false);
}

const drawWrinkleContours = (context, wrinkle_contours, lineWidth) => {
    context.fillStyle = 'rgba(24, 96, 3, 0.5)';
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(24, 96, 3, 0.5)";
    drawContours(context, wrinkle_contours, true, true);
}

const drawRosaceaContours = (context, eye_contours, filter) => {
    context.filter = filter;
    context.fillStyle = 'rgba(206, 66, 66, 0.5)';
    drawContours(context, eye_contours, true, false);
}

const drawTextureContours = (context, eye_contours, lineWidth) => {
    context.lineWidth = lineWidth;
    context.filter = 'none';
    context.strokeStyle = "rgba(186, 111, 223, 0.5)";
    drawContours(context, eye_contours, false, true);
}

const drawDarkSpotsContours = (context, darkspots_contours, lineWidth) => {
    context.fillStyle = 'rgba(81, 212, 191, 0.4)';
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(81, 212, 191, 0.4)";
    drawContours(context, darkspots_contours, true, false);
}

const drawAcneContours = (context, acne_contours, lineWidth) => {
    context.fillStyle = 'rgba(234, 220, 96, 0.4)';
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(234, 220, 96, 0.4)";
    drawContours(context, acne_contours, true, false);
}

const drawContours = (context, contours, fill, stroke) => {
    for (let i = 0; i < contours.length; i++) {
        drawContour(context, contours[i], fill, stroke)
    }
}

const drawContour = (context, contour_coordinates, fill = false, stroke = false) => {
    context.beginPath();
    for (let i = 0; i < contour_coordinates.length; i++) {
        let point = contour_coordinates[i]
        if (i == 0) {
            context.moveTo(point[0], point[1]);
        } else {
            context.lineTo(point[0], point[1]);
        }
    }
    context.closePath();
    if (fill) context.fill();
    if (stroke) context.stroke();
}

// Getting current canvas click position
function getCursorPosition(canvas, event) {

    const ctx = canvas.getContext('2d');
    const bb = canvas.getBoundingClientRect();
    var point = {
        _x: Math.floor((event.clientX - bb.left) / bb.width * canvas.width),
        _y: Math.floor((event.clientY - bb.top) / bb.height * canvas.height)
    }

    var skin_conditions = ["acne", "darkspots", "wrinkles", "dark_circles", "rosacea"];
    var click_found = false;
    for (var sc = 0; sc < skin_conditions.length; sc++) {
        if (isPointInsidePoligon(point, tangent_facemap_data[skin_conditions[sc]])) {
            openConditionMessage(canvas, skin_conditions[sc]);
            click_found = true;
            break;
        }
    }
    if (!click_found) {
        tangent_condition_message_popoup.style.display = "none";
        console.log("no condition click");
    }
}

function openConditionMessage(canvas, condition) {
    tangent_condition_message_popoup.innerHTML = condition_text_mapping[condition];
    let rect = canvas.getBoundingClientRect();
    var point = {
        _x: event.clientX - rect.left,
        _y: event.clientY - rect.top
    }

    // Positioning Popup
    Object.assign(
        tangent_condition_message_popoup.style,
        {
            display: "block",
            left: (point._x) + "px",
            top: (point._y) + "px"
        }
    );
}


// Check whether click is inside condition points
function isPointInsidePoligon(pt, points_list) {
    // https://stackoverflow.com/a/29915728/960654
    // ray-casting algorithm based on
    // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html

    var x = pt._x,
        y = pt._y

    var inside = false;
    for (var c = 0; c < points_list.length; c++) {
        var points = points_list[c];
        for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
            var xi = points[i][0],
                yi = points[i][1]
            var xj = points[j][0],
                yj = points[j][1]

            var intersect =
                yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
            if (intersect) inside = !inside
        }
    }
    return inside
}